import { useQuery } from '@tanstack/react-query';
import { billingApi } from '@features/settings/api/billingApi';

/**
 * Single source of truth for the tenant's subscription/license status.
 *
 * Shares the React-Query key `['billing','current']` with the BillingPage so the
 * status bar, the AppShell expiry gate, and the page all read one cached fetch.
 *
 * FAIL-OPEN: `blocked` is true ONLY for a confirmed `status === 'expired'`. While
 * loading or on error we never block, so a transient API hiccup can't lock a
 * paying tenant out of the app.
 */
export function useSubscription() {
  const query = useQuery({
    queryKey: ['billing', 'current'],
    queryFn: billingApi.current,
    staleTime: 60_000,
    retry: false,
  });
  const blocked = query.data?.status === 'expired';
  return { ...query, blocked };
}
